<template>
  <div id="lebac" v-if="storeJobsDatas && appReady" role="main">
    
    <!-- Bouton pour basculer en mode plein écran -->
    <div id="cornerTopRight">
      <langueSwitch
        v-if="storeJobsDatas"
        class="pictoMini"
        :langue="storeUrlArray.langue || 'fr'"
        aria-label="Changer la langue"
        role="button"
      />
      <div
        class="pictoMini notOnMobile"
        v-if="storeEcran !== 'mobile'"
        @click="toggleFullscreenMode"
        :style="{ backgroundImage: `url(${isFullscreen ? 'interface/exit_fullscreen.svg' : 'interface/enter_fullscreen.svg'})` }"
        role="button"
        tabindex="0"
        :aria-label="isFullscreen ? 'Quitter le mode plein écran' : 'Passer en plein écran'"
        @keydown.enter="toggleFullscreenMode"
        @keydown.space="toggleFullscreenMode"
      >
      </div>
    </div>

    <!-- ✅ GARDER : modalMessage sans modification -->
    <modalMessage 
       v-if="storeJobsDatas && storeUrlArray.langue"
       :langue="storeUrlArray.langue || 'fr'" 
      :translations="formattedTranslations"
      class="fade-in-speed" 
    />

    <!-- ✅ MODIFIÉ : listeGlobal avec condition pour mobile -->
    <listeGlobal
      v-if="storeJobsDatas && storeUrlArray.langue && shouldShowListeGlobal"
      :langue="storeUrlArray.langue || 'fr'"
      :style="dynamicStyles.listeGlobal"
      class="fade-in-speed"
    />
    
    <!-- ✅ MODIFIÉ : ficheViewer avec condition pour mobile -->
    <ficheViewer
      v-if="storeJobsDatas && storeUrlArray.uuid != '' && !hideFiche && shouldShowFicheViewer"
      :ficheArray="storeJobsDatas?.jobs[this.storeUrlArray.id || 0]"
      :langue="storeUrlArray.langue || 'fr'"
      :translations="formattedTranslations"
      :style="dynamicStyles.ficheViewer"
      class="fade-in-speed"
    />

    <adminPanel
      ref="adminPanel"
      @reset-to-rag0="resetToRag0"
      :dataVersion="storeJobsDatas.info.date"
    />
  </div>
  <div v-else class="loader">Chargement…</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import listeGlobal from './components/listeGlobal.vue';
import ficheViewer from './components/ficheViewer.vue';
import modalMessage from './components/elements/modalMessage.vue';
import langueSwitch from './components/elements/langueSwitch.vue';
import adminPanel from './components/elements/adminPanel.vue';
import debounce from 'lodash/debounce';

export default {
  name: 'LeBac',
  components: {
    listeGlobal,
    ficheViewer,
    modalMessage,
    langueSwitch,
    adminPanel
  },
  data() {
    return {
      // ✅ SUPPRIMER : modeAdmin du data local
      // modeAdmin: false,
      isFullscreen: false,
      screenWidth: window.innerWidth,
      // ✅ AJOUTER : Timestamp unique
      buildTimestamp: new Date().toISOString().slice(0, 16).replace('T', ' '),
      appReady: false
    }
  },
  computed: {
    // ✅ AJOUTER : modeAdmin dans le mapState
    ...mapState(['storeJobsDatas','storeEcran', 'ficheOn', 'storeUrlArray', 'hideFiche', 'modeAdmin']),
    
    formattedTranslations() {
      const translations = this.storeJobsDatas?.translations;
      
      if (!translations) {
        return {};
      }
      
      if (typeof translations === 'object' && !Array.isArray(translations)) {
        return translations;
      }
      
      if (Array.isArray(translations)) {
        return translations.reduce((acc, item, index) => {
          acc[index] = item;
          return acc;
        }, {});
      }
      
      return {};
    },
    
    // ✅ NOUVEAU : Gérer la visibilité de listeGlobal
    shouldShowListeGlobal() {
      if (this.screenWidth < 1100) {
        return this.ficheOn === false;
      }
      // En mode desktop : toujours afficher listeGlobal
      return true;
    },
    
    // ✅ NOUVEAU : Gérer la visibilité de ficheViewer
    shouldShowFicheViewer() {
      if (this.screenWidth < 1100) {
        return this.ficheOn === true;
      }
      // En mode desktop : toujours afficher ficheViewer
      return true;
    },
    
    dynamicStyles() {
      if (this.hideFiche) {
        return {
          listeGlobal: 'border-radius: 10px !important;',
          ficheViewer: 'border-radius: 10px !important;'
        };
      }

      if (this.screenWidth < 1100) {
        return {
          listeGlobal: 'border-radius: 0 !important;',
          ficheViewer: 'border-radius: 0 !important;'
        };
      } else if (this.screenWidth < 1700) {
        return {
          listeGlobal: 'border-radius: 10px 0 0 10px !important;',
          ficheViewer: 'border-radius: 0 10px 10px 0 !important;'
        };
      } else {
        return {
          listeGlobal: 'border-radius: 10px !important;',
          ficheViewer: 'border-radius: 10px !important;'
        };
      }
    }
  },
  
  async created() {
    console.log('🚀 Chargement du JSON...');
    
    try {
      // ✅ CORRECT : Utiliser fetchstoreJobsDatas (avec 's')
      await this.fetchstoreJobsDatas();
      console.log('✅ JSON chargé');
      
      
    } catch (error) {
      console.error('❌ Erreur lors du chargement:', error);
    }
  },
  
  mounted() {
    // ✅ AJOUTER : Changer le titre dynamiquement
    document.title = `R agency • Refs`;
    
    this.handleWindowResizeDebounced = debounce(this.handleWindowResize, 200);
    window.addEventListener('resize', this.handleWindowResizeDebounced);
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    window.addEventListener('keydown', this.handleKeyDown);
    this.handleWindowResize();

    // ✅ SIMPLE : Log final
    console.log('✅ App.vue et composants prêts !');
    
    // ✅ GARDER : Debug des translations
    this.$watch('storeJobsDatas', (newVal) => {
      if (newVal) {
        console.log('🔍 Structure des translations:', typeof newVal.translations);
      }
    }, { immediate: true });

    console.log('Styles appliqués à listeGlobal:', this.dynamicStyles.listeGlobal);

    // Pause d'une seconde avant d'afficher l'app
    setTimeout(() => {
      this.appReady = true;
    }, 500);

    // Attendre que les fontes soient chargées
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

    // Attendre aussi le chargement des données (storeJobsDatas)
    const dataReady = new Promise((resolve) => {
      const check = () => {
        if (this.storeJobsDatas && Object.keys(this.storeJobsDatas).length > 0) {
          resolve();
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });

    // Afficher l'app seulement quand tout est prêt
    Promise.all([fontsReady, dataReady]).then(() => {
      this.appReady = true;
    });
  },
  
  methods: {
    // ✅ CORRECT : Utiliser fetchstoreJobsDatas avec 's'
    ...mapActions(['updateStateValue', 'configViaUrl', 'fetchstoreJobsDatas','updateStoreUrl', 'toggleHideFiche', 'setHideFiche']),


    // ✅ GARDER : Seulement les méthodes actuelles
    handleKeyDown(event) {
      // Empêcher l'action si on est dans un champ de saisie
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }
      
      if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'r') {
        this.$refs.adminPanel.activate();
      }
    },
    
    // ✅ AJOUTER : Méthode complète pour la touche "R"
    resetToRag0() {
      try {
        // 1. Forcer hideFiche à false
        this.setHideFiche(false);
        
        // 2. Définir uuid à 'rag0'
        this.updateStoreUrl({ tag: 'uuid', value: 'rag0' });
        
        // 3. Optionnel : Remettre d'autres paramètres par défaut
        this.updateStoreUrl({ tag: 'section', value: 0 });
                
        // 4. Animation flash pour indiquer le changement
        document.body.classList.add('flash');
        setTimeout(() => {
          document.body.classList.remove('flash');
        }, 200);
        
        // 5. Appliquer les border-radius après le reset
        this.$nextTick(() => {
          this.applyBorderRadius();
        });
        
      } catch (error) {
        console.error('❌ Erreur lors du reset:', error);
      }
    },

    // ✅ MODIFIER : Utiliser l'action du store
    toggleFiche() {
      this.toggleHideFiche(); // ✅ Utiliser l'action du store
      console.log(`🔄 Fiche ${this.hideFiche ? 'masquée' : 'affichée'} (touche "i")`);
      
      document.body.classList.add('flash');
      setTimeout(() => {
        document.body.classList.remove('flash');
      }, 200);
    },

    handleWindowResize() {
      const width = window.innerWidth;
      this.screenWidth = width;
      console.log('screenWidth mis à jour:', this.screenWidth);

      // ✅ Appliquer les styles dynamiques après la mise à jour de screenWidth
      this.applyBorderRadius();
    },

    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
    },

    

    toggleAdminMode() {
      this.modeAdmin = !this.modeAdmin;
    },

    createQuickLink() {
      this.updateStateValue({
        key: 'storeModalMessage',
        value: 'quicklink',
      });
    },

    addIdToHistory(value) {
      if (!this.uniqueHistory.includes(value)) {
        this.uniqueHistory.push(value);
        this.updateStateValue({
          key: 'storeHistoryUuId',
          value: this.uniqueHistory,
        });
      }
    },

    enableFullscreen() {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },

    disableFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },

    toggleFullscreenMode() {
      if (!this.isFullscreen) {
        this.enableFullscreen();
      } else {
        this.disableFullscreen();
      }
    },

    updateBrowserUrl(newParams) {
      const params = new URLSearchParams(newParams);

      ['filtre', 'sousfiltre', 'uuid', 'section'].forEach((key) => {
        const value = params.get(key);
        params.set(key, parseInt(value) || 0);
      });

      const langue = params.get('langue');
      if (!['fr', 'en'].includes(langue)) {
        params.set('langue', 'fr');
      }

      const newUrl = `?${params.toString()}`;
      window.history.pushState({}, '', newUrl);
    },
    
    applyBorderRadius() {
      const listeGlobal = document.getElementById('listeGlobal');
      const ficheViewer = document.getElementById('ficheViewer');

      console.log('hideFiche:', this.hideFiche);
      console.log('screenWidth:', this.screenWidth);

      if (this.hideFiche) {
        console.log('Appliquer border-radius: hide-fiche');
        if (listeGlobal) listeGlobal.style.borderRadius = '10px';
        if (ficheViewer) ficheViewer.style.borderRadius = '10px';
      } else if (this.screenWidth < 1100) {
        console.log('Appliquer border-radius: none');
        if (listeGlobal) listeGlobal.style.borderRadius = '0';
        if (ficheViewer) ficheViewer.style.borderRadius = '0';
        // this.storeEcran = 'mobile'; // ✅ CORRECT : Mettre à jour le storeEcran
        this.updateStateValue({ key: 'storeEcran', value: 'mobile' });
      } else if (this.screenWidth < 1700) {
        console.log('Appliquer border-radius: left/right');
        if (listeGlobal) listeGlobal.style.borderRadius = '10px 0 0 10px';
        if (ficheViewer) ficheViewer.style.borderRadius = '0 10px 10px 0';
      } else {
        console.log('Appliquer border-radius: full');
        if (listeGlobal) listeGlobal.style.borderRadius = '10px';
        if (ficheViewer) ficheViewer.style.borderRadius = '10px';
      }
    },
  },

  watch: {
    'storeUrlArray.uuid': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updateStateValue({ key: 'hideFiche', value: false });
          this.updateStateValue({ key: 'ficheOn', value: true });
          console.log('🔄 Changement de fiche:', newVal);
          // Utilise l'action du store pour sauvegarder
          this.$store.dispatch('saveActionToMemo', {
            action: 'fiche',
            tag: 'uuid',
            value: newVal
          });
        }
      },
    },
  
    'storeUrlArray.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updateStateValue({ key: 'storeUrlArray', value: { ...this.storeUrlArray, id: newVal } });
        }
      },
    },
    
    hideFiche() {
      this.$nextTick(() => {
        this.applyBorderRadius();
      });
    },
    
    screenWidth() {
      this.$nextTick(() => {
        this.applyBorderRadius();
      });
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleWindowResizeDebounced);
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    window.removeEventListener('keydown', this.handleKeyDown);
  }
};
</script>

<style>
:root {
  /* dimension */
  --hauteur: 45vw; /* Hauteur de diapo et fiche et aussi largeur de diapo */
  --largeurInfos: 400px; /* Largeur de la zone d'infos */
  --largeurListe: 400px; /* Largeur de la liste */
  --largeurListeMini: 350px; /* Largeur de la liste */
  --largeurMaxMobile: 500px;

  --marge: 2vw;
  --colorLight: #c1e5e3;
  --colorVeryLight: #e0fbfa;
  --colorDark: #000e31;
  --colorDark-rgb: 116, 166, 211;
  --colorVeryDark-rgb: 2, 10, 32;
  --colorActive: #fb4639;
  --colorVeryDark: #020a20;
  --colorWhite: white;
}
html {
  background-color: var(--colorDark);
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  display: flex;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100vw;
  overflow: hidden;
  color: var(--colorVeryDark)
}

#lebac {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: var(--hauteur);
}

/*-------------------------------------------------------- */ 

h1{
  font-family: 'Alumni Sans', Arial, Helvetica, sans-serif;
  font-size: 50px;
  font-weight: 200;
  line-height: 0.8; 
}

h2 { /* pa sutilisé  */
  font-family: 'Alumni Sans', Arial, Helvetica, sans-serif;
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
h3{
  font-family: 'Bitter', serif;
  font-size: 16px;
  margin: 15px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
  padding: 0;
}
h4{
   font-family: 'Alumni Sans', Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 0.8;
}
h5{
  font-family: 'Alumni Sans', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 0.8;
  margin: 0;
}
h6 { /* tag */
  font-family: 'Bitter', serif;
  font-size: 10px;
  line-height: 1.1;
  font-weight: 500;
  margin: 0 6px 6px 0;
}
p{
  font-size: 12px;
}


.modal-content h1, .modal-content h2 {
  margin: 10px;
}
.ligneNom {
  font-family: 'Alumni Sans', Arial, Helvetica, sans-serif;
  font-size: 22px;
  padding: 10px 0 10px 10px;
  font-weight: 200;
  line-height: 0.9;
  letter-spacing: 0.3px;
}
.bouttons{
   display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  margin: 0 6px 6px 0 !important;
  min-width: 20px;
  height: 20px;
  cursor: pointer;
}
.bouttons:hover, .bouttons.active {
  background-color: var(--colorDark) !important;
  color: var(--colorWhite) !important;
  cursor: pointer;
}

.action {
  background-color: var(--colorWhite);
  margin: 20px 5px 0 0px;
}

.zone{
  background-color: var(--colorVeryDark);
  color: var(--colorLight);
}

#navTop {
  background-color: var(--colorWhite);
  color: var(--colorDark);
}


.bgFx {
  background: linear-gradient(to bottom, var(--colorDark), var(--colorVeryDark));
}

.lienFiche{
  background-color: var(--colorLight);
}
.lienFiche:hover{
  background-color: var(--colorDark);
  color: var(--colorWhite);
  
}
.bouttons .nombre{
  background-color: var(--colorDark);
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
}

/* -------------------------------------- */
/* ---------------- LISTE --------------- */
/* -------------------------------------- */


/* ✅ CORRIGER : Style par défaut quand hideFiche = false */
#listeGlobal {
  margin-right: 20px;
  width: var(--largeurListe);
  overflow: hidden;
}

/* -------------------------------------- */
/* ---------------- FICHE --------------- */
/* -------------------------------------- */

#ficheViewer {
  height: var(--hauteur);
  width: auto !important;
  max-width: none !important;
  min-width: auto !important;
  flex-shrink: 0 !important;
}



#zoneInfos {
  width: var(--largeurInfos) !important;
}

#zoneDiapo {
  transition: all 0.3s;
  aspect-ratio: 1 / 1;
}

/* -------------------------------------- */
/* ---------------- SCROLL -------------- */
/* -------------------------------------- */

.scrollMinimal {
  overflow-y: auto;
}
/* Custom scrollbar styles */
.scrollMinimal::-webkit-scrollbar {
  width: 3px; /* Width of the scrollbar */
}

.scrollMinimal::-webkit-scrollbar-track {
  background-color: var(--colorVeryDark);
}

.scrollMinimal::-webkit-scrollbar-thumb {
  border-radius: 0; /* Rounded corners */
  background-color: var(--colorLight);
}

#cornerTopRight{
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  margin: 20px 20px 0 0vw;
  z-index: 1001;
  flex-direction: row;
  color: var(--colorWhite)
}

#btBack {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  margin: 20px 0 0 20px;
  background-size: contain;
  background-image: url('/public/interface/back.svg');
}

.pictoMini {
  width: 25px;
  height: 25px;
  background-size: contain;
  margin-left: 10px;
  cursor: pointer;
}


/* animation ------------------------------------------------------- */

.fade-in {
  opacity: 0;
  animation: fadeIn 1s forwards;
  animation-delay: 0.1s; /* pause de 0.5s avant de démarrer l'animation */
}
.fade-in-speed {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}



@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* ✅ AJOUTER : Animation flash pour indiquer le changement */
.flash {
  animation: flash 0.2s ease-in-out;
}

@keyframes flash {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}




@media screen and (max-width: 1700px) {
  :root {
    --hauteur: 50vw !important;
    --largeurInfos: 300px !important;
    --largeurListe: 300px !important;
  }

   #ficheViewer {
    width: auto !important;
    max-width: none !important;
    min-width: auto !important;
  }
  #listeGlobal {
    margin-right: 0;
  }


  
  .break {
    display: none;
  }

}



@media screen and (max-width: 1300px) {
   :root {
    --hauteur: 45vw !important;
    --largeurInfos: 280px !important;
    --largeurListe: 300px !important;
  }

}


/* resolution mobile ------------------------------------------------------- */

@media screen and (max-width: 1100px) {
  /* !!!!!!!!!!  ça semble pas focntionner */
   :root {
    --hauteur: 100dvh !important;;
    --largeurInfos: 100vw !important;;
    --largeurListe: 300px !important;;
    --marge: 20px !important;
  }
  #lebac, #ficheViewer {
    max-width: var(--largeurMaxMobile) !important;
    height: 100dvh !important;
  }

  #listeGlobal {
    margin-right: 0;
    min-width: 100%;
  }

  h1{
  }
  #lebac {
    flex-flow: column wrap;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  #ficheViewer {
    height: 100vh;
    width: auto;
  }
  #listeGlobal {
    margin-right: 0;
    min-width: 100%;
    height: 100%;
  }

  .notOnMobile{
    display: none;
  }
  #barTop {
    margin: 8px 8px 0 0;
  }
  .bouttons:hover  {
    background-color: var(--colorLight);
    color: var(--colorDark);
  }
  .bouttons {
    border-radius: 10px;
    margin: 0;
  }
  .firstBt{
    border-radius: 10px;
  }
  .lastBt{
    border-radius: 10px;
  }
  .soloBt{
    border-radius: 10px;
  }
}
</style>